import { createApp } from 'vue'
import options from './SearchAndCTACancerforum.options'

const el = '.kb-component--search-and-cta-cancerforum'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SearchAndCTACancerforumDOM) => {
            const template = SearchAndCTACancerforumDOM.outerHTML
            options.template = template
            const component = createApp(options, {
                guid: SearchAndCTACancerforumDOM.dataset.guid,
                groupId: SearchAndCTACancerforumDOM.dataset.groupId,
                loginUrl: SearchAndCTACancerforumDOM.dataset.loginUrl,
                isLoggedIn: SearchAndCTACancerforumDOM.hasAttribute('is-logged-in'),
                isClosedGroup: SearchAndCTACancerforumDOM.hasAttribute('is-closed-group'),
                isUserAwaitingAccess: SearchAndCTACancerforumDOM.hasAttribute('is-awaiting-access')
            }).use(Store)
            component.mount(SearchAndCTACancerforumDOM)
        })
    }
}
